/**
 * 공통 네비게이션 Store
 * @description 헤더, 네비게이션, 레이아웃 관련 상태 관리
 * startup, investor, myspace 등 모든 앱에서 공통으로 사용
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NavigationState {
  // 헤더 관련
  headerTitle: string;
  higherMenu: string | null;
  backPath: string | null;
  restartIntro: (() => void) | null;
  
  // 네비게이션 표시 관련
  isNavCollapsed: boolean;
  activePath: string[];
  
  // 헤더 액션
  setHeaderTitle: (title: string) => void;
  setBackNavigation: (menu: string | null, path: string | null) => void;
  clearBackNavigation: () => void;
  setRestartIntro: (fn: (() => void) | null) => void;
  
  // 네비게이션 액션  
  setNavCollapsed: (collapsed: boolean) => void;
  toggleNavCollapsed: () => void;
  setActivePath: (path: string[]) => void;
  setNavigationClear: () => void;
}

/**
 * 공통 네비게이션 Store
 * 
 * 헤더 상태:
 * - headerTitle: 페이지 타이틀
 * - higherMenu: 상위 메뉴명 (뒤로가기용)
 * - backPath: 뒤로가기 경로
 * - restartIntro: 튜토리얼 재시작 함수
 * 
 * 네비게이션 상태:
 * - isNavCollapsed: 네비게이션 접힘 상태
 * - activePath: 현재 활성 경로
 */
export const useNavigationStore = create<NavigationState>()(
  persist(
    (set) => ({
      // 헤더 관련 초기값
      headerTitle: '',
      higherMenu: '',
      backPath: '',
      restartIntro: null,
      
      // 네비게이션 관련 초기값      
      isNavCollapsed: false,
      activePath: [],
      
      // 헤더 액션
      setHeaderTitle: (title) => set({ headerTitle: title }),
      setBackNavigation: (menu, path) => set({ higherMenu: menu, backPath: path }),
      clearBackNavigation: () => set({ higherMenu: null, backPath: null }),
      setRestartIntro: (fn) => set({ restartIntro: fn }),
      
      // 네비게이션 액션      
      setNavCollapsed: (collapsed) => set({ isNavCollapsed: collapsed }),
      toggleNavCollapsed: () => set((state) => ({ isNavCollapsed: !state.isNavCollapsed })),
      setActivePath: (path) => set({ activePath: path }),
      setNavigationClear: () => set({ headerTitle: '' }),
    }),
    {
      name: 'navigation-storage',
      partialize: (state) => ({
        headerTitle: state.headerTitle,        
        isNavCollapsed: state.isNavCollapsed,
        higherMenu: state.higherMenu,
        backPath: state.backPath,
        activePath: state.activePath,
        // restartIntro는 persist에서 제외 (함수는 저장 불가)
      }),
    }
  )
);

export default useNavigationStore;

